/**
 * Ground the welcome row keeps above it when it opens a sitting at the top of
 * the viewport — the same `pt-2` a fresh transcript's first row sits under.
 */
export const WELCOME_TOP_INSET_PX = 8;

export interface IWelcomeTailSpacerInput {
  /** The scroll container's `clientHeight`. */
  viewportHeight: number;
  /** Height of the transcript column measured with the spacer collapsed. */
  contentHeight: number;
  /** The welcome row's top edge, in scroll-content coordinates. */
  welcomeOffsetTop: number;
}

/**
 * Height of the blank run appended after the transcript's last row so that
 * "scrolled to the bottom" lands the welcome row at the top of the viewport.
 *
 * A fresh sitting opens by inserting the welcome under the rehydrated history,
 * and the viewer should meet the welcome first, not the history above it. When
 * the rows under the welcome are shorter than the viewport, the bottom of the
 * scroll range would otherwise leave that history in view; the spacer extends
 * the range by exactly the shortfall, so the pinned auto-follow and
 * "welcome at the top" are the same scroll position. It shrinks as replies
 * fill the sitting and reaches zero once they overflow the viewport, at which
 * point ordinary bottom-following takes over.
 */
export function welcomeTailSpacerHeight({
  viewportHeight,
  contentHeight,
  welcomeOffsetTop,
}: IWelcomeTailSpacerInput): number {
  const belowWelcome = contentHeight - welcomeOffsetTop;
  return Math.max(0, Math.round(viewportHeight - belowWelcome - WELCOME_TOP_INSET_PX));
}
